import angular = require('angular');
import { RetailerService } from '../api/retailer.service';
import { HttpService } from '../../../app.common/modules/api/http.service';
import { SalesAssistantRatingPagingResult, SalesAssistantSummaryResourceModel, SalesAssistantPagingResult, SalesAssistantPagingSettings, SalesAssistantRatingPagingSettings, SalesAssistantFeedbackStats, SalesAssistantRatingSettings } from '../core';
import _ = require('underscore');


export class StaffRatingService {
    static $inject = ['http', 'retailerService', '$httpParamSerializer'];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService,
        private $serializer: ng.IHttpParamSerializer
    ) { }


    getColumnSort(name?: string, isAsc?: boolean) {
        return {
            column: name ? name : 'Name',
            order: 0,
            asc: 0,
            desc: 1,
            isAsc: _.isUndefined(isAsc) ? true : isAsc,
            set: function (name: string, isAsc: boolean) {
                if (_.isUndefined(isAsc)) {
                    this.isAsc = !this.isAsc;
                } else {
                    this.isAsc = isAsc;
                }
                this.column = name ? name : 'Name';
                this.order = this.isAsc ? this.asc : this.desc;
            },
            sort: function (list: any[], field: string, asc: boolean) {
                return asc ? _.sortBy(list, field) : _.sortBy(list, field).reverse();
            },

            isSelected: function (field: string) {
                return this.column === field;
            }
        };
    }

    getStaffRatingSummary( isArchived: boolean) {
        return this.http.get<SalesAssistantFeedbackStats>(this.retailerService.staffRatingSummary(isArchived));
    }

    getStaffRatingData(filter: SalesAssistantPagingSettings) {
        return this.http.get<SalesAssistantPagingResult>( this.retailerService.staffRatingData (filter.Offset, filter.Limit, filter.SortColumn, filter.SortOrder, filter.IsActive));
    }

    getStaffRatingSummaryByID(id: number) {
        return this.http.get<SalesAssistantSummaryResourceModel>(this.retailerService.staffRatingSummaryByID(id));
    }

    getStaffRatingDataByID(id: number, filter: SalesAssistantRatingPagingSettings) {
        return this.http.get<SalesAssistantRatingPagingResult>(this.retailerService.staffRatingDataByID(id, filter.Offset, filter.Limit, filter.SortColumn, filter.SortOrder,
            filter.StartDate ? filter.StartDate.toISOString() : null, filter.EndDate ? filter.EndDate.toISOString() : null));
    }

    setStaffRatingSettings(model: SalesAssistantRatingSettings) {
        return this.http.post<void>(this.retailerService.staffRatingSettings(), model);
    }

    getShopperAvatarUrl(id: number, width?: number, height?: number) {
        let baseUrl = this.retailerService.retailerShopper();
        let params = this.$serializer({ width: width, height: height });
        return `${baseUrl}/avatar/${id}?${params}`;
    }

    getSalesAssistantCsv(query: SalesAssistantPagingSettings) {
        return this.http.get<any>(this.retailerService.exportSalesAssistant(), { params: query });
    }
}

angular
    .module('naut')
    .service('staffRatingService', StaffRatingService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/staffRating/staffRating.service.ts